import { get } from 'lodash';

const root = state => get(state, 'ReportsState.itemListingReports');

export const getItemListingReportData = state =>
  get(root(state), 'itemListingReportData', []);
export const getLoading = state => get(root(state), 'loading', false);



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/itemlistingreport/state/selectors.js